import { Skeleton } from '@components';
import styles from '../../search/InfiniteHits/InfiniteHits.module.scss';

const ProductGridSkeleton = ({ className }) => {
	return (
		<div className={className ?? styles['tops']}>
			{Array.from({ length: 9 }).map((_, index) => (
				<Skeleton key={index} height={300} width='100%' borderRadius={'0.4rem'} type={'rect'} />
			))}
		</div>
	);
};

export default ProductGridSkeleton;
